// Import everything from autoload folder
import './autoload/ada-compliance.js'; import './autoload/foundation.js'; // eslint-disable-line
// Import local dependencies
import './plugins/lazyload';
import './plugins/modernizr.min';
import 'slick-carousel';
import 'jquery-match-height';
import objectFitImages from 'object-fit-images';
import '@fancyapps/fancybox/dist/jquery.fancybox.min';
// import { jarallax, jarallaxElement } from 'jarallax';
import ScrollOut from 'scroll-out';

/*global  ajax_object*/
/**
 * Import scripts from Custom Divi blocks
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/divi/example-block/index.js';
/**
 * Import scripts from Custom Elementor widgets
 */
// eslint-disable-next-line import/no-unresolved
//import '../blocks/elementor/example-widget/index.js';
/**
 * Import scripts from Custom ACF Gutenberg blocks
 */
// eslint-disable-next-line import/no-unresolved
import '../blocks/gutenberg/acf-custome-title-block/index.js'; import '../blocks/gutenberg/acf-example-block/index.js'; import '../blocks/gutenberg/acf-faq-block/index.js'; import '../blocks/gutenberg/acf-location-archive-block/index.js'; import '../blocks/gutenberg/acf-map-block/index.js'; import '../blocks/gutenberg/acf-sold-out-block/index.js'; import '../blocks/gutenberg/acf-sub-hero-block/index.js'; import '../blocks/gutenberg/acf-tax-slider-block/index.js'; import '../blocks/gutenberg/acf-team-block/index.js'; import '../blocks/gutenberg/acf-testimonials-block/index.js'; import '../blocks/gutenberg/acf-three-images-block/index.js'; import '../blocks/gutenberg/acf-video-gallery-block/index.js';

/**
 * Init foundation
 */
$(document).foundation();

/**
 * Fit slide video background to video holder
 */
function resizeVideo() {
  let $holder = $('.videoHolder');
  $holder.each(function() {
    let $that = $(this);
    let ratio = $that.data('ratio') ? $that.data('ratio') : '16:9';
    let width = parseFloat(ratio.split(':')[0]);
    let height = parseFloat(ratio.split(':')[1]);
    $that.find('.video').each(function() {
      if ($that.width() / width > $that.height() / height) {
        $(this).css({
          width: '100%',
          height: 'auto',
        });
      } else {
        $(this).css({
          width: ($that.height() * width) / height,
          height: '100%',
        });
      }
    });
  });
}

/**
 * Scripts which runs after DOM load
 */

$(document).on('ready', function() {
  document
    .querySelector('.mobile-nav-toggle')
    .addEventListener('click', function() {
      this.classList.toggle('active');
    });
  /**
   * Make elements equal height
   */
  jQuery(document).ready(function($) {
    var currentPage = 1;
    var maxPages = $('#load-more-news').data('max-pages');
    var scipPost = $('#load-more-news').data('skip-post');

    $('#load-more-news').on('click', function() {
      currentPage++;

      var selectedDate = $('#news-date').val();
      var selectedCategory = $('#news-category').val();
      $.ajax({
        url: ajax_object.ajax_url, // WordPress AJAX URL
        type: 'POST',
        dataType: 'json',
        data: {
          action: 'load_more_news',
          scipPost: scipPost,
          paged: currentPage,
          date: selectedDate,
          category: selectedCategory,
        },
        beforeSend: function() {
          $('#load-more-news').text('Loading...').prop('disabled', true);
        },
        success: function(response) {
          if (response.posts) {
            $('#news-container').append(response.posts);
            $('#load-more-news').text('Load More').prop('disabled', false);

            if (currentPage >= response.max_page) {
              $('#load-more-news').hide();
            }
          } else {
            $('#load-more-news').hide();
          }
        },
      });
    });
  });

  $('.matchHeight').matchHeight();

  /**
   * IE Object-fit cover polyfill
   */
  if ($('.of-cover').length) {
    objectFitImages('.of-cover');
  }

  function initMap() {
    var map = new google.maps.Map(document.getElementById('map'), {
      zoom: 10,
      center: { lat: 30.2672, lng: -97.7431 },
      styles: [
        {
          stylers: [{ color: '#f5f5f5' }],
        },
        {
          elementType: 'labels.icon',
          stylers: [{ visibility: 'off' }],
        },
        {
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
        },
        {
          elementType: 'labels.text.stroke',
          stylers: [{ color: '#f5f5f5' }],
        },
        {
          featureType: 'administrative.land_parcel',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#bdbdbd' }],
        },
        {
          featureType: 'poi',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'poi',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'poi.park',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'road',
          elementType: 'geometry',
          stylers: [{ color: '#ffffff' }],
        },
        {
          featureType: 'road.arterial',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#757575' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'geometry',
          stylers: [{ color: '#dadada' }],
        },
        {
          featureType: 'road.highway',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#616161' }],
        },
        {
          featureType: 'road.local',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'transit.line',
          elementType: 'geometry',
          stylers: [{ color: '#e5e5e5' }],
        },
        {
          featureType: 'transit.station',
          elementType: 'geometry',
          stylers: [{ color: '#eeeeee' }],
        },
        {
          featureType: 'water',
          elementType: 'geometry',
          stylers: [{ color: '#c9c9c9' }],
        },
        {
          featureType: 'water',
          elementType: 'labels.text.fill',
          stylers: [{ color: '#9e9e9e' }],
        },
        {
          featureType: 'poi.business',
          stylers: [{ visibility: 'off' }],
        },
      ],
    });

    var bounds = new google.maps.LatLngBounds();
    var markers = [];

    const marker_available = `${window.location.origin}/wp-content/themes/liberationranches/assets/images/apps_maps_marker_5.png`;
    const marker_sold = `${window.location.origin}/wp-content/themes/liberationranches/assets/images/apps_maps_marker_9.png`;
    const marker_under_contact = `${window.location.origin}/wp-content/themes/liberationranches/assets/images/apps_maps_marker_8.png`;
    const marker_claster = `${window.location.origin}/wp-content/themes/liberationranches/assets/images/m1.png`;

    $.each(mapLocations, function(index, location) {
      let markerIcon;

      // Convert specs to lowercase for case-insensitive matching
      switch (location.specs.toLowerCase()) {
        case 'sold':
          markerIcon = marker_sold;
          break;
        case 'available':
          markerIcon = marker_available;
          break;
        case 'under contract':
          markerIcon = marker_under_contact;
          break;
        default:
          markerIcon = marker_available; // Default marker
      }
      var marker = new google.maps.Marker({
        position: { lat: location.lat, lng: location.lng },
        title: location.title,
        category: location.category,
        icon: {
          url: markerIcon, // Set the correct marker image
          scaledSize: new google.maps.Size(40, 40), // Adjust icon size if needed
        },
      });

      var infoWindow = new google.maps.InfoWindow({
        content:
          '<div style="max-width: 250px;">' +
          '<a href="' +
          location.permalink +
          '" target="_blank" style="text-decoration: none;">' +
          '<img src="' +
          (location.thumbnail ||
            'https://your-default-image-url.com/default.png') +
          '" alt="' +
          location.title +
          '" style="width:100%; height:auto; border-radius:5px; margin-bottom:5px;">' +
          '</a>' +
          '<strong><a href="' +
          location.permalink +
          '" target="_blank" style="text-decoration:none; color:#0593bd;">' +
          location.title +
          '</a></strong><br>' +
          location.address +
          '<br>' +
          '<strong>' +
          location.specs +
          '</strong> ' +
          '<br>' +
          '<a href="' +
          location.permalink +
          '" target="_blank" style="display:inline-block; margin-top:5px; color:#0593bd;">View Details</a>' +
          '</div>',
      });

      marker.addListener('click', function() {
        infoWindow.open(map, marker);
      });

      bounds.extend(marker.position);
      markers.push(marker);

      // Create category label next to the marker (if needed)
    });
    const clusterStyles = [
      {
        height: 10,
        width: 10,
        textColor: '#ffffff', // White text inside the cluster
        textSize: 14,
        backgroundColor: '#b76028',
      },
    ];

    const addedCategories = new Set(); // Track added categories

    new markerClusterer.MarkerClusterer({
      map,
      markers,
      renderer: {
        render: ({ count, position, markers }) => {
          // Get the first marker's category from the markers in the cluster
          const firstMarker = markers[0];
          const category = firstMarker.category;

          // Create the cluster marker
          const clusterMarker = new google.maps.Marker({
            position,
            icon: {
              url: marker_claster, // Use the custom cluster image
              scaledSize: new google.maps.Size(50, 50), // Adjust the size if needed
            },
            label: {
              text: count.toString(),
              color: '#ffffff',
              fontSize: '12px',
              fontWeight: 'bold',
            },
          });

          // Only add category label if it hasn't been added yet
          if (!addedCategories.has(category)) {
            new ClusterLabel(category, map, position);
            addedCategories.add(category); // Mark this category as added
          }
          return clusterMarker;
        },
      },
    });

    if (mapLocations.length > 0) {
      map.fitBounds(bounds);
    }
  }

  function ClusterLabel(text, map, position) {
    this.text = text;
    this.map = map;
    this.position = position;
    this.div = null;
    this.setMap(map);
  }

  ClusterLabel.prototype = new google.maps.OverlayView();

  ClusterLabel.prototype.onAdd = function() {
    var div = document.createElement('div');
    div.className = 'cluster-label';
    div.style.position = 'absolute';
    div.style.background = '#b76028';
    div.style.color = '#fff';
    div.style.padding = '3px 5px';
    div.style.borderRadius = '0px';
    div.style.fontSize = '10px';
    div.style.fontWeight = 'bold';
    div.style.textTransform = 'uppercase';
    div.style.whiteSpace = 'nowrap';
    div.innerHTML = this.text;

    this.div = div;
    var panes = this.getPanes();
    panes.overlayLayer.appendChild(div);
  };

  ClusterLabel.prototype.draw = function() {
    var projection = this.getProjection();
    var position = projection.fromLatLngToDivPixel(this.position);

    this.div.style.left = position.x + 20 + 'px'; // Adjust position near the cluster
    this.div.style.top = position.y - 20 + 'px';
  };

  ClusterLabel.prototype.onRemove = function() {
    if (this.div) {
      this.div.parentNode.removeChild(this.div);
      this.div = null;
    }
  };

  if (typeof google !== 'undefined') {
    initMap();
  }
  /**
   * Add fancybox to images
   */
  $('.gallery-item')
    .find('a[href$="jpg"], a[href$="png"], a[href$="gif"]')
    .attr('rel', 'gallery')
    .attr('data-fancybox', 'gallery');
  $(
    '.fancybox, a[rel*="album"], a[href$="jpg"], a[href$="png"], a[href$="gif"]',
  ).fancybox({
    minHeight: 0,
    helpers: {
      overlay: {
        locked: false,
      },
    },
  });

  /**
   * Init parallax
   */
  // jarallaxElement();
  // jarallax(document.querySelectorAll('.jarallax'), {
  //   speed: 0.5,
  // });

  /**
   * Detect element appearance in viewport
   */
  ScrollOut({
    offset: function() {
      return window.innerHeight - 200;
    },
    once: true,
    onShown: function(element) {
      if ($(element).is('.ease-order')) {
        $(element)
          .find('.ease-order__item')
          .each(function(i) {
            let $this = $(this);
            $(this).attr('data-scroll', '');
            window.setTimeout(function() {
              $this.attr('data-scroll', 'in');
            }, 300 * i);
          });
      }
    },
  });

  /**
   * Remove placeholder on click
   */
  const removeFieldPlaceholder = () => {
    $('input, textarea').each((i, el) => {
      $(el)
        .data('holder', $(el).attr('placeholder'))
        .on('focusin', () => {
          $(el).attr('placeholder', '');
        })
        .on('focusout', () => {
          $(el).attr('placeholder', $(el).data('holder'));
        });
    });
  };

  removeFieldPlaceholder();

  $(document).on('gform_post_render', () => {
    removeFieldPlaceholder();
  });

  /**
   * Scroll to Gravity Form confirmation message after form submit
   */
  $(document).on('gform_confirmation_loaded', function(event, formId) {
    let $target = $('#gform_confirmation_wrapper_' + formId);
    if ($target.length) {
      $('html, body').animate({ scrollTop: $target.offset().top - 50 }, 500);
      return false;
    }
  });

  /**
   * Hide gravity forms required field message on data input
   */
  $('body').on(
    'change keyup',
    '.gfield input, .gfield textarea, .gfield select',
    function() {
      let $field = $(this).closest('.gfield');
      if ($field.hasClass('gfield_error') && $(this).val().length) {
        $field.find('.validation_message').hide();
      } else if ($field.hasClass('gfield_error') && !$(this).val().length) {
        $field.find('.validation_message').show();
      }
    },
  );

  /**
   * Add `is-active` class to menu-icon button on Responsive menu toggle
   * And remove it on breakpoint change
   */
  $(window)
    .on('toggled.zf.responsiveToggle', function() {
      $('.menu-icon').toggleClass('is-active');
    })
    .on('changed.zf.mediaquery', function() {
      $('.menu-icon').removeClass('is-active');
    });

  /**
   * Close responsive menu on orientation change
   */
  $(window).on('orientationchange', function() {
    setTimeout(function() {
      if ($('.menu-icon').hasClass('is-active') && window.innerWidth < 641) {
        $('[data-responsive-toggle="main-menu"]').foundation('toggleMenu');
      }
    }, 200);
  });

  resizeVideo();
});

/**
 * Scripts which runs after all elements load
 */
$(window).on('load', function() {
  // jQuery code goes here

  let $preloader = $('.preloader');
  if ($preloader.length) {
    $preloader.addClass('preloader--hidden');
  }
});

/**
 * Scripts which runs at window resize
 */
$(window).on('resize', function() {
  // jQuery code goes here

  resizeVideo();
});

/**
 * Scripts which runs on scrolling
 */
$(window).on('scroll', function() {
  // jQuery code goes here
});
document.addEventListener('DOMContentLoaded', function() {
  function animateOnScroll(
    blockSelector,
    contentSelector,
    mediaSelector,
    threshold = 0.2,
  ) {
    const mediaTextBlocks = document.querySelectorAll(blockSelector);

    const observerOptions = {
      root: null,
      rootMargin: '0px',
      threshold: threshold,
    };

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          const block = entry.target;
          const content = block.querySelector(contentSelector);
          const media = block.querySelector(mediaSelector);

          if (content) content.classList.add('fade-in-right');
          if (media)
            media.classList.add(
              block.classList.contains('has-media-on-the-right')
                ? 'fade-in-right'
                : 'fade-in-left',
            );

          observer.unobserve(block);
        }
      });
    }, observerOptions);

    mediaTextBlocks.forEach((block) => observer.observe(block));
  }

  animateOnScroll(
    '.wp-block-media-text',
    '.wp-block-media-text__content',
    '.wp-block-media-text__media',
  );
  animateOnScroll(
    '.three-images__wp',
    '.three-images',
    '.three-images__content',
  );
});

jQuery(document).ready(function($) {
  $('a[href^="#"]').on('click', function(event) {
    event.preventDefault();

    var target = $(this.getAttribute('href'));
    if (target.length) {
      var headerHeight = $('.header').outerHeight() || 0;
      var notificationsHeight = $('.notifications-bar').outerHeight() || 0;
      var totalOffset = headerHeight + notificationsHeight;

      $('html, body').animate({
        scrollTop: target.offset().top - totalOffset,
      }, 500);
    }
  });
});


